/* eslint-disable camelcase */
import React, { ReactElement, useMemo, useState, useEffect } from 'react';
import { $k18n } from '@/common/i18n';
import { TouchableWithoutFeedback, Text, View, Dimensions, ViewStyle } from 'react-native';
import ImagePreview from '@kibt/meta-ui-krn/lib/components/ImagePreview';
import { useDetailPageStore } from '@/page/detail/store';
// 样式
import { convertStyles } from '@kibt/krn-utils';

import { KView, PageContext } from '@/component/RtlLayout';
import SrcStyles from './index.styl';
const Styles = convertStyles(SrcStyles);

import { PageRowData, Sku, Spec, ItemSpecValue } from '../../../api';

import MyImage from '../MyImage';
import CloseWithBackground from '@/assets/icon_detail/closeWithBackground.png';
import ClosePng from '@/assets/icon_detail/close.png';
import Popup from '@kibt/meta-ui-krn/lib/components/Popup';
import yoda from '@kibt/bridge';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import {
    logClickImgFullSwitch,
    logClickSelectSpec,
    logClickSpecImgContiner,
    logShowHalfSpecPage,
    logShowMessage,
    onSpecAddCartVisible,
} from '../../../logger2.0';
import { isIOS, isAndroid, isWeb, windowHeight, screenHeight } from '@/common/device-info';
import { useABHandler } from '../../../useABHandler';
import { useDraggableHeight } from '@/hooks/useDraggableHeight';
import { useFixedPosition, useIosFixedNativeID } from '@/hooks/useFixedPosition';
import { useQuery } from '@/hooks/useQuery';
import { HorizontalGestureConflictView } from '@/component/SpaHorizontalGestureConflictView';
import { useUpdateEffect } from 'ahooks';
import { SpecSelectArea } from './components/SpecSelectArea';
import { SpecHeader } from './components/SpecHeader';
import { OptionBarButton } from './components/OptionBarButton';
import { SpecLinePopSke } from './components/SpecLinePopSke';
import { Toast } from '@kibt/meta-ui-krn';
import { isFixedViewSupport } from '@/component/FixedView';
import { backOrClose } from '@/common/bridge/backOrClose';

type IProps = {
    pageRawData: PageRowData;
    showDetailUrl?: string | boolean; // 直播间小黄车拉起规格半屏
    // changeStep: (num: GUIDE_ENUM) => () => void;
    closeSpec: (toast?: string) => void;
    isPopVisible: boolean;
    type: string;
    addCartItem?: (sku: any, num: number, sellerMerchantId?: any, callShouldGoToAddonHelper?: boolean) => Promise<boolean>;
    foldRatio?: string | number;
    addToCartAnimation?: Function;
    // 是否展示修改数量的组件
    showChangeCount?: boolean;
    // 默认选中的规格
    defaultSelectedItems?: { [key: string]: any };
    onConfirm?: (sku: any, purchaseQuantity: number) => void;
    openHalfConfirmOrder?: boolean;
    autoBottomGap?: boolean;
    customDuration?: number;
    pageActiveStatus?: number;
    page?: string; //当前规格半屏页来源
    showAfterCouponPrice: boolean;
    isFrom?: string;
    // 是否要打开凑单页
    shouldGoToAddonHelper?: (before?: () => Promise<boolean>, from?: 'cart' | 'buy') => Promise<boolean>;
    // 同时展示加购和购买按钮（短视频凑单）
    showCartAndCheckout?: boolean;
    popupStyle?: any;
    retrievalInfo?: Record<any, string>;
    extParamsCustom?: any; // 如果别的页面引用多规格购买组件，可自定义传入跳转提单的归因来源
    ifUseDetailStore?: boolean; // 是否使用商详页的store
    isReco?: boolean; // 是否是reco的商品打开的规格半屏页
    isSpecPage?: boolean; // 是否是规格半屏页【容器级别】
    scene?: number | string;
};
function SpecLine(props: IProps): ReactElement {
    const {
        pageRawData,
        closeSpec,
        isPopVisible,
        type, //  buy/cart/confirm
        addCartItem, // 触发外层加购接口
        foldRatio,
        addToCartAnimation,
        showDetailUrl = '',
        showChangeCount = true,
        openHalfConfirmOrder = false,
        autoBottomGap = false,
        customDuration = 150,
        pageActiveStatus,
        showAfterCouponPrice = false,
        isFrom,
        showCartAndCheckout = false,
        popupStyle = {},
        retrievalInfo,
        extParamsCustom,
        ifUseDetailStore = false,
        isReco = false,
        shouldGoToAddonHelper,
        onConfirm: customConfirm,
        defaultSelectedItems,
        isSpecPage = false,
        scene,
    } = props;
    const { outterSpecImageIndex, outterPurchaseQuantity, outterCurrentSku, outterimmediateAvailableQuantity } = useDetailPageStore((s) => ({
        outterPurchaseQuantity: s.purchaseQuantity,
        outterSpecImageIndex: s.specImageIndex,
        outterCurrentSku: s.currentSku,
        outterimmediateAvailableQuantity: s.immediateAvailableQuantity,
    }));
    const setStoreState = useDetailPageStore().setState;
    const getStoreState = useDetailPageStore().getState;
    const [specLinePopState, setSpecLinePopState] = useState({
        purchaseQuantity: 1,
        specImageIndex: -1,
        currentSku: {} as Sku,
        immediateAvailableQuantity: 0,
    });

    const { currentSku, purchaseQuantity, specImageIndex } = specLinePopState;
    const setPurchaseQuantity = (num) => {
        setSpecLinePopState((pre) => ({
            ...pre,
            purchaseQuantity: num,
        }));
        if (ifUseDetailStore) getStoreState().setPurchaseQuantity(num);
    };

    const setCurrentSku = (current) => {
        setSpecLinePopState((pre) => ({
            ...pre,
            currentSku: current,
        }));
        if (ifUseDetailStore) setStoreState({ currentSku: current });
    };

    // 初始化规格区轮播图 第一张主图 + 所有的规格图
    const [isNotAllImg, setIsNotAllImg] = useState(false);
    const [specImageUrls, setSpecImageUrls] = useState([]);

    // 如果筛选规格第一行的每个规格， 都有规格图
    useEffect(() => {
        const productMainImage = pageRawData && pageRawData?.imageUrls && pageRawData?.imageUrls[0];
        // 图片优化的主图
        const productMainImageOpt = pageRawData && pageRawData?.templateImageUrls && pageRawData?.templateImageUrls[0];
        const imageArr = [productMainImageOpt || productMainImage];

        if (pageRawData?.specs?.[0]?.itemSpecValues?.[0]?.imageUrl && pageRawData?.specs?.[0]?.itemSpecValues?.[0]?.imageUrl !== '') {
            setIsNotAllImg(false);
            pageRawData?.specs[0].itemSpecValues?.forEach((item) => {
                imageArr.push(item.templateImageUrl || item.imageUrl);
            });
        } else {
            setIsNotAllImg(true);
        }

        setSpecImageUrls([...imageArr]);
    }, [pageRawData]);

    const setSpecImageIndex = (index, changeSwiperIndex = true) => {
        setSpecLinePopState((pre) => ({
            ...pre,
            specImageIndex: index,
        }));
        if (ifUseDetailStore) {
            // 如果不是商详页当前的商品规格半屏，不修改swiper的index
            if (!isNotAllImg && ifUseDetailStore) {
                if (index > -1) {
                    setStoreState({
                        swiperImageIndex: getStoreState().detailImageurls.length + index,
                        specImageIndex: index,
                    });
                } else {
                    setStoreState({ specImageIndex: -1 });
                    if (changeSwiperIndex) setStoreState({ swiperImageIndex: 0 });
                }
            } else {
                setStoreState({
                    specImageIndex: index,
                });
            }
        }
    };

    useEffect(() => {
        if (ifUseDetailStore) {
            setSpecLinePopState({
                currentSku: outterCurrentSku as Sku,
                purchaseQuantity: outterPurchaseQuantity,
                specImageIndex: outterSpecImageIndex,
                immediateAvailableQuantity: outterimmediateAvailableQuantity,
            });
        }
    }, [outterCurrentSku, outterPurchaseQuantity, outterSpecImageIndex, ifUseDetailStore]);
    const { detailABValueMap } = useABHandler();
    const minNum = (pageRawData?.minPurchase as number) ?? 1;
    const showUpStepper = detailABValueMap?.if_spec_num_up && isFrom === 'detail';

    const skuSpecTypes = [
        { specName: $k18n({ id: 'k_226117', text: '规格' }), specId: 1 },
        { specName: $k18n('颜色'), specId: 2 },
        { specName: $k18n('图案'), specId: 3 },
        { specName: $k18n('材质'), specId: 5 },
        { specName: $k18n('口味'), specId: 6 },
        { specName: $k18n('色号'), specId: 7 },
        { specName: $k18n('容量'), specId: 8 },
        { specName: $k18n('度数'), specId: 9 },
        { specName: $k18n('功效'), specId: 10 },
        { specName: $k18n('型号'), specId: 11 },
        { specName: $k18n('内存'), specId: 12 },
        { specName: $k18n('尺寸'), specId: 13 },
        { specName: $k18n('重量'), specId: 14 },
        { specName: $k18n('厚度'), specId: 15 },
        { specName: $k18n('适用肤质'), specId: 16 },
        { specName: $k18n('使用人群'), specId: 17 },
        { specName: $k18n('适用性别'), specId: 18 },
        { specName: $k18n('适用年纪'), specId: 19 },
        { specName: $k18n('适用季节'), specId: 20 },
        { specName: $k18n('货号'), specId: 21 },
        { specName: $k18n('尺'), specId: 22 },
        { specName: $k18n('款式'), specId: 23 },
    ];
    const skuSpecTypesMap = {};
    skuSpecTypes?.forEach((item) => {
        skuSpecTypesMap[item.specId] = item.specName;
    });

    const skuInfo =
        pageRawData && pageRawData?.skus
            ? pageRawData?.skus.map((sku) => {
                  const skuInfoItem = {};
                  sku.skuSpecs?.forEach((spec) => {
                      skuInfoItem[spec.specId] = spec.specValueId;
                  });
                  return {
                      ...skuInfoItem,
                      ...sku,
                  };
              })
            : [];

    // selectedKV {"specId": specValueId}
    const [selectedKV, setSelectedKV] = useState({});

    useEffect(() => {
        if (ifUseDetailStore) return;
        setSelectedKV({});
        setSpecLinePopState({
            purchaseQuantity: 1,
            specImageIndex: -1,
            currentSku: {} as Sku,
            immediateAvailableQuantity: 0,
        });
    }, [pageRawData?.itemId, isPopVisible]);

    const containerHeightState = useDraggableHeight();

    // 用来存储选中的规格参数
    // selectedItems selectedItems [{"imageUrl": "", "label": "blue", "specId": 2, "specValueId": 129033, "specValueName": "blue", "specValueSortNum": 2, "templateImageUrl": "", "value": 129033}]
    const selectedItems = useMemo(() => {
        const res = [] as ItemSpecValue[];
        Object.keys(selectedKV).map((specId) => {
            const value = selectedKV[specId];
            if (!value) return;
            const spec = pageRawData?.specs.find((_spec) => String(_spec?.specId) === String(specId)) || ({} as Spec);
            const targetSpec = spec.itemSpecValues?.find((itemSpecValue) => itemSpecValue.specValueId === value);
            targetSpec && res.push(targetSpec);
        });
        return res;
    }, [selectedKV]);

    const clearFirstLineSpec = () => {
        const specId = pageRawData?.specs?.[0]?.specId;
        if (specId) {
            selectedKV[specId] = null;
            setSelectedKV({ ...selectedKV });
        }
    };

    // 命中商详页返回时引导加购弹窗时，增加'popup'类型的埋点上报
    const addType = getStoreState()?.alertVisible?.specPupoup ? 'popup' : '';
    // 关闭引导弹窗时，重置type
    const resetAlertVisibleType = () => {
        getStoreState().setAlertVisible({
            ...getStoreState().alertVisible,
            specPupoup: false,
        });
    };

    const isDisabled = (item, spec: Spec) => {
        // 自营测品 放开限制
        if (pageRawData?.extraInfo?.selfOperated && type === 'cart') {
            return false;
        }
        const key = spec?.specId;
        const value = item?.value;
        const selectedReplaced = JSON.parse(JSON.stringify(selectedKV));
        if (key) selectedReplaced[key] = value;

        const flag = skuInfo.some((skuItem) => {
            return Object.keys(selectedKV).every((key) => {
                if (selectedReplaced[key]) {
                    // 库存小于最低加购时，不能选
                    return skuItem[key] === selectedReplaced[key] && skuItem.availableQuantity >= minNum;
                }
                return true;
            });
        });

        return !flag;
    };

    // 动态库存
    useEffect(() => {
        const res = [] as any;
        skuInfo?.forEach((skuItem) => {
            const flag = selectedItems.every((item) => item && skuItem[item?.specId] === item.specValueId);
            if (flag) {
                res.push(skuItem);
            }
        });
        const availableQuantity = res.reduce((cur, next) => {
            return cur + next.availableQuantity;
        }, 0);
        console.log('immediateAvailableQuantity >>>> 1', availableQuantity);
        ifUseDetailStore &&
            availableQuantity !== getStoreState().immediateAvailableQuantity &&
            setStoreState({
                immediateAvailableQuantity: availableQuantity,
            });
        setSpecLinePopState((p) => ({ ...p, immediateAvailableQuantity: availableQuantity }));
    }, [selectedItems]);
    useUpdateEffect(() => {
        const availableQuantity = specLinePopState.immediateAvailableQuantity;
        console.log('specLinePopState.immediateAvailableQuantity', ifUseDetailStore, availableQuantity);
        if (ifUseDetailStore) return;
        if (
            (Number(availableQuantity) > 0 && Number(availableQuantity) < minNum) ||
            (selectedItems.length && (Number(availableQuantity) === 0 || Number(availableQuantity) < minNum))
        ) {
            Toast.show({ text: $k18n('抱歉，商品已售罄') });
        }
    }, [specLinePopState.immediateAvailableQuantity]);
    useEffect(() => {
        // specImageIndex只影响主规格
        if (!ifUseDetailStore) return;
        setSpecImageIndex(outterSpecImageIndex, false);
        if (outterSpecImageIndex === -1) {
            selectedKV[pageRawData?.specs?.[0]?.specId] = null;
            setSelectedKV({ ...selectedKV });
            setCurrentSku({});
            return;
        }
        const _type = pageRawData?.specs?.[0];
        const item = pageRawData?.specs?.[0]?.itemSpecValues?.[outterSpecImageIndex];
        const key = _type?.specId;
        const value = item?.specValueId;

        // 修改选中项
        const sameSpecId = selectedItems.findIndex((spec) => item?.specId === spec?.specId && item.specValueId === spec.specValueId);
        if (sameSpecId === -1) {
            if (selectedKV[key] !== value) {
                selectedKV[key] = value;
                setSelectedKV({ ...selectedKV });
                if (item && _type && isDisabled(item, _type)) {
                    logShowMessage(pageRawData?.itemId, 2);
                }
            }
        }
        const current = skuInfo.find((skuItem) => {
            if (pageRawData.specs.length) {
                return pageRawData.specs.every((_spec) => {
                    return selectedKV[_spec.specId] === skuItem[_spec.specId];
                });
            } else {
                return false;
            }
        });
        if (current) {
            setCurrentSku(current);
        } else {
            setCurrentSku({});
        }
    }, [ifUseDetailStore, outterSpecImageIndex]);

    const selectItem = (item: ItemSpecValue, spec: Spec, level, index, canSelect = true) => {
        // 有重新勾选规格的行为，就要把购买数量重置为最低起购
        const watchSelectedIndex = (_specImageIndex) => {
            setSpecImageIndex(_specImageIndex);
        };
        setPurchaseQuantity(minNum);
        // 如果选择的是第一行的规格
        if (level === 0) {
            // index 是规格的位置，specImageIndex是被选中规格的位置
            // 相等说明是，取消选中
            if (index === specImageIndex) {
                watchSelectedIndex(-1);
            } else {
                // 不相等说明是，更换选中
                watchSelectedIndex(index);
            }
        }

        logClickSelectSpec();
        const key = spec?.specId; // 具体是 重量
        const value = item?.specValueId; // 具体是 1kg 2kg

        // 修改选中项
        if (selectedKV[key] !== value) {
            selectedKV[key] = value;
            setSelectedKV({ ...selectedKV });
            if (canSelect) {
                logShowMessage(pageRawData?.itemId, 2);
            }
        } else {
            selectedKV[key] = null;
            setSelectedKV({ ...selectedKV });
        }
        const current = skuInfo.find((skuItem) => {
            if (pageRawData.specs.length) {
                return pageRawData.specs.every((_spec) => {
                    return selectedKV[_spec.specId] === skuItem[_spec.specId];
                });
            } else {
                return false;
            }
        });
        if (current) {
            setCurrentSku(current);
        } else {
            setCurrentSku({});
        }
    };

    useEffect(() => {
        if (Object.keys(selectedKV).length) return;
        if (defaultSelectedItems) {
            pageRawData?.itemId &&
                pageRawData?.specs?.forEach((spec, level) => {
                    const curSpec = defaultSelectedItems[spec?.specId];
                    if (curSpec) {
                        const selectedValueIndex = spec.itemSpecValues.findIndex((item) => item.specValueId === curSpec.specValueId);
                        if (selectedValueIndex !== -1) {
                            const item = spec.itemSpecValues[selectedValueIndex];
                            selectItem(item, spec, level, selectedValueIndex, false);
                        }
                    }
                });
        }
    }, [JSON.stringify(defaultSelectedItems), pageRawData?.itemId]);

    const queryItemId = useQuery('itemId');
    const openSlideFullScreen = useQuery<string>('openSlideFullScreen');

    useEffect(() => {
        // 秒杀商品部分sku达到限购时（banner位的图片轮播切换、预览切换、主界面价格组件切换规格，规格半屏切换规格）
        if (pageRawData?.activityInfo?.activityId && [2, 4, 5].includes(pageRawData?.activityInfo?.status) && currentSku?.activityLimitCount === 0) {
            Toast.show({
                text: $k18n({ id: 'k_407823', text: '抱歉，您已达该规格活动购买上限，去看看其他规格' }),
                duration: 1000,
            });
            return;
        }
    }, [currentSku, pageRawData?.activityInfo?.activityId, pageRawData?.activityInfo?.status]);

    const [showImageViewer, setShowImageViewer] = useState(false);
    const clickImgPre = () => {
        setShowImageViewer(true);
        logClickSpecImgContiner(pageRawData?.itemId);
    };

    // 关闭弹窗
    const onHandleCloseSpec = () => {
        if (isSpecPage) return backOrClose();
        resetAlertVisibleType();
        setPurchaseQuantity(minNum);
        closeSpec();
    };

    const onChangeImageView = (idx) => {
        const type = pageRawData?.specs[0];
        const level = 0;

        // index 切换到1 就相当于点击了第一个规格
        if (idx > 0) {
            const index = idx - 1;
            const item = pageRawData?.specs[0].itemSpecValues[index];
            selectItem(item, type, level, index);
        } else if (idx === 0) {
            setSpecImageIndex(-1);
            selectedKV[pageRawData?.specs?.[0]?.specId] = null;
            setSelectedKV({ ...selectedKV });
            setCurrentSku({});
            clearFirstLineSpec();
        }
        logClickImgFullSwitch(idx);
    };

    const [bottomPosition, setBottomPosition] = useState(0);

    // 这部分逻辑是为了适配rnios的可拖拽半屏吸底
    const checkIsHalfByBridgeAsync = async () => {
        const isHalfPage = containerHeightState.pageStatus === 'halfScreen';
        // 印尼krn不需要设置bottom
        if (autoBottomGap) {
            setBottomPosition(0);
        } else if (isHalfPage && isIOS) {
            console.log('isHalfPage', isHalfPage, foldRatio);
            const foldRatioNum = foldRatio ? Number(foldRatio) : 1;
            setBottomPosition(Dimensions.get('window').height * (1 - foldRatioNum));
        } else {
            setBottomPosition(0);
        }
    };

    useEffect(() => {
        containerHeightState.init && checkIsHalfByBridgeAsync();
    }, [isPopVisible, foldRatio, containerHeightState.init]);

    const onSlidingStatusChange = (data) => {
        const res = JSON.parse(data);
        if (res.status === 4) {
            onHandleCloseSpec();
        }
        // status 3 全屏； 4 半屏； 1 容器拖拽中
        // {"status":3,"availableSize":{"width":414,"height":896},"rect":{"y":0,"x":0,"width":414,"height":896},"safeArea":{"bottom":34,"top":48,"left":0,"right":0}}
    };

    useEffect(() => {
        // @ts-ignore
        yoda.event.addEventListener('krn_bottom_sheet_on_sliding_status_change', onSlidingStatusChange, ({ result }) => {
            // addEventListener bridge 本身是否调用成功
            if (result === 1) {
                // 成功
                console.log('addEventListener success');
            } else {
                // 失败
                console.log('addEventListener failed');
            }
        });
    }, []);

    const position = useFixedPosition();

    // 备注 这部分逻辑是解决半屏弹窗层级问题 需要配合组件库最新版本
    // 底部购买按钮 z-index 为 600
    // 三个z-index
    const popUpProps = () => {
        if (isFrom === 'detail-coudan') {
            return {
                maskZindex: 550,
                boxStyle: { position },
            };
        }
        return {};
    };
    const popUpPropsImagePreview = () => {
        if (isFrom === 'detail-coudan') {
            return {
                maskZindex: 650,
                boxStyle: { position },
            };
        }
        return {};
    };
    const ImgPreview = (
        <ImagePreview
            autoPlay={false}
            useScrollView={true}
            maskZindex={150}
            {...popUpPropsImagePreview()}
            customCloseIcon={(active) => {
                return (
                    <View style={{ position: 'absolute', width: 100, height: 100, paddingLeft: 20, paddingTop: 34, zIndex: 10 }}>
                        <MyImage imageSrc={CloseWithBackground} styleObj={{ width: 42, height: 42 }} />
                    </View>
                );
            }}
            customStyle={{ indicatorTop: 44 }}
            images={specImageUrls}
            beforeClose={() => {
                setShowImageViewer(false);
            }}
            // 如果没有规格图，只展示一张商品主图，这时候startPosition需要单独设置成0
            startPosition={specImageUrls.length > 1 ? specImageIndex + 1 : 0}
            onChange={onChangeImageView}
            visible={showImageViewer}
            closeable
            closeIconPosition={'top-left'}
            // closeIcon={{ uri: 'https://aws-static.kwai.net/udata/pkg/proweb/shop/c/swipeleft.3a47309cfa69d1fd.png' }}
            onClose={() => {
                setShowImageViewer(false);
            }}
            boxStyle={{ zIndex: 999, ...(isFixedViewSupport ? { position: 'fixed' } : { position }) } as ViewStyle}
            loop={true}
            cropOption={{ ratio: 0.5 }}
            customCover={(active) => {
                return specImageIndex >= 0 && pageRawData?.specs[0] && pageRawData?.specs[0].itemSpecValues[specImageIndex] ? (
                    <View
                        style={{
                            position: 'absolute',
                            width: 414,
                            bottom: '20%',
                            left: 0,
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <View
                            style={{
                                paddingTop: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                paddingRight: 8,
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: 'rgba(0, 0, 0, 0.32)',
                                borderRadius: 12,
                            }}
                        >
                            <Text style={{ color: '#fff', fontWeight: 'bold', fontSize: 14 }}>
                                {pageRawData?.specs[0].itemSpecValues[specImageIndex].specValueName}
                            </Text>
                        </View>
                    </View>
                ) : null;
            }}
        />
    );

    const fixedState = useIosFixedNativeID();
    const bundleId = useQuery<string>('bundleId');
    const popupContent = () => {
        const popupContentStyle = (() => {
            // 小黄车是客户端专门创建的固定容器，和其它不一样，需要单独处理，
            // 如果有其它容器也是和小黄车容器一样的话也需要加进来
            const isConstContainer = ['ShoppingCar'].includes(bundleId) && isAndroid;
            const mb = isConstContainer
                ? {
                      marginBottom: 0,
                  }
                : {};
            if (isFixedViewSupport && isConstContainer) {
                return {
                    bottom: 0,
                    position: 'relative',
                    height: containerHeightState.pageStatus === 'halfScreen' ? containerHeightState.height : windowHeight * 0.75,
                    marginBottom: (isAndroid ? containerHeightState.pageStatus === 'halfScreen' : +openSlideFullScreen === 1)
                        ? windowHeight - containerHeightState.height
                        : 0,
                    ...mb,
                };
            }
            // 如果是规格单独页面，并且不支持固底组件，视口高度就是容器高度，直接设置组件高度为’100%‘
            if (isSpecPage && !isFixedViewSupport) {
                return {
                    height: '100%',
                };
            } else if (isSpecPage && isFixedViewSupport) {
                // 如果是规格单独页面，并且支持固底组件，视口高度不是容器高度，容器高度是屏幕高度，直接设置组件paddingBottom
                return {
                    position: 'relative',
                    height: '100%',
                    paddingBottom: (isAndroid ? containerHeightState.pageStatus === 'halfScreen' : +openSlideFullScreen === 1)
                        ? windowHeight - containerHeightState.height + 20
                        : 20,
                };
            } else if (isFixedViewSupport) {
                return {
                    bottom: 0,
                    position: 'relative',
                    height: containerHeightState.pageStatus === 'halfScreen' ? containerHeightState.height : windowHeight * 0.75,
                    marginBottom: (isAndroid ? containerHeightState.pageStatus === 'halfScreen' : +openSlideFullScreen === 1)
                        ? windowHeight - containerHeightState.height
                        : 0,
                };
            } else
                return {
                    bottom: bottomPosition,
                    // ios半屏状态下需要给popup设置容器高度，而不能设置成'100%'，设置1000%会让popup的高度为屏幕高度
                    height: isWeb ? '75vh' : isIOS ? screenHeight * 0.75 : containerHeightState.pageStatus === 'halfScreen' ? '100%' : '75%',
                    width: '100%',
                    position,
                };
        })() as ViewStyle;
        // 这里使用containerHeightState.init是为了防止容器状态没拿到和拿到状态后导致组件闪动。
        if (!containerHeightState.init) return null;
        return pageRawData?.itemId && pageRawData?.specs.length ? (
            <PageContext.Provider value={{ Styles }}>
                <KView rtlClassName={'spec'} style={[popupContentStyle]} nativeID={!isFixedViewSupport ? fixedState.nativeID : ''}>
                    <KView rtlClassName={'spec-close-top-right'}>
                        {/* ViewVisible直接包裹popup子元素无法触发曝光埋点，改为包裹孙子元素 */}
                        <ViewVisible
                            onVisible={
                                props.type === 'buy'
                                    ? logShowHalfSpecPage
                                    : () =>
                                          onSpecAddCartVisible({
                                              type: addType,
                                              // 如果是reco商品打开的规格半屏，source需要是recommend
                                              source: Number(queryItemId) === Number(pageRawData?.itemId) ? 'current' : isReco ? 'recommend' : '',
                                              releated_item_id: String(queryItemId),
                                          })
                            }
                        >
                            <TouchableWithoutFeedback onPress={() => onHandleCloseSpec()}>
                                <KView rtlClassName={'spec-close-top-right-img-wrapper'}>
                                    <MyImage imageSrc={ClosePng} styleObj={{ width: 28, height: 28 }} />
                                </KView>
                            </TouchableWithoutFeedback>
                        </ViewVisible>
                    </KView>
                    <SpecHeader
                        pageRawData={pageRawData}
                        specImageIndex={specImageIndex}
                        currentSku={currentSku}
                        showDetailUrl={showDetailUrl}
                        isNotAllImg={isNotAllImg}
                        detailABValueMap={detailABValueMap}
                        showAfterCouponPrice={showAfterCouponPrice}
                        skuInfo={skuInfo}
                        selectedItems={selectedItems}
                        clickImgPre={clickImgPre}
                        type={type}
                        showUpStepper={showUpStepper}
                        immediateAvailableQuantity={specLinePopState.immediateAvailableQuantity}
                        purchaseQuantity={purchaseQuantity}
                        setPurchaseQuantity={setPurchaseQuantity}
                        scene={scene}
                        extParamsCustom={extParamsCustom}
                    />
                    <SpecSelectArea
                        pageRawData={pageRawData}
                        selectedKV={selectedKV}
                        selectItem={selectItem}
                        immediateAvailableQuantity={specLinePopState.immediateAvailableQuantity}
                        currentSku={currentSku}
                        purchaseQuantity={purchaseQuantity}
                        setPurchaseQuantity={setPurchaseQuantity}
                        showChangeCount={showChangeCount}
                        showUpStepper={showUpStepper}
                    />
                    <OptionBarButton
                        pageRawData={pageRawData}
                        selectedKV={selectedKV}
                        currentSku={currentSku}
                        purchaseQuantity={purchaseQuantity}
                        type={type}
                        immediateAvailableQuantity={specLinePopState.immediateAvailableQuantity}
                        isFrom={isFrom}
                        showCartAndCheckout={showCartAndCheckout}
                        pageActiveStatus={pageActiveStatus}
                        addCartItem={addCartItem}
                        addToCartAnimation={addToCartAnimation}
                        shouldGoToAddonHelper={shouldGoToAddonHelper}
                        openHalfConfirmOrder={openHalfConfirmOrder}
                        retrievalInfo={retrievalInfo}
                        extParamsCustom={extParamsCustom}
                        customConfirm={customConfirm}
                        isReco={isReco}
                    />
                </KView>
            </PageContext.Provider>
        ) : (
            <PageContext.Provider value={{ Styles }}>
                <KView rtlClassName={'spec'} style={popupContentStyle} nativeID={fixedState.nativeID}>
                    <SpecLinePopSke />
                </KView>
            </PageContext.Provider>
        );
    };
    const PopupNode = isSpecPage ? (
        popupContent()
    ) : (
        <Popup
            lockScroll={true}
            visible={isPopVisible}
            duration={customDuration || 150}
            onClose={() => onHandleCloseSpec()}
            position="bottom"
            style={[
                {
                    zIndex: 120,
                },
                popupStyle,
            ]}
            {...popUpProps()}
            {...(isFixedViewSupport
                ? {
                      boxStyle: { zIndex: 900 },
                  }
                : {})}
        >
            {popupContent()}
        </Popup>
    );
    const FinalNode = isAndroid ? PopupNode : showImageViewer ? null : PopupNode;
    return isPopVisible ? (
        <>
            {FinalNode}
            <HorizontalGestureConflictView>{ImgPreview}</HorizontalGestureConflictView>
        </>
    ) : null;
}
export default SpecLine;
